
import { defineComponent, PropType } from 'vue'
import useRoll from './useRoll'
import { RollType, SkillProgress } from '@/types'
import { Button } from '@/shared/ui'
import RollResult from '@/shared/ui/RollResult/RollResult.vue'
import RollDifficulty from '@/features/RollSkillDice/part/RollDifficulty.vue'
import SkillBubble from '@/features/RollSkillDice/part/SkillBubble.vue'

export default defineComponent({
	name: 'RollBase',
	components: {
		SkillBubble,
		RollDifficulty,
		RollResult,
		Button
	},
	props: {
		skill: {
			type: Object as PropType<SkillProgress>,
			required: true
		},
		rollType: {
			type: String as PropType<RollType>,
			required: true
		}
	},
	setup(props) {
		return useRoll(props.skill, props.rollType)
	}
})
